import { importActions } from '../../services';

export const importDispatcher = dispatch => ( {
  importExcel: file => dispatch( { type: importActions.IMPORT, data: file } ),
  validate: data => dispatch( { type: importActions.VALIDATE, data } )
} );
